<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Registro de Rubros</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Registro de Rubros</strong>
          </div>
          <b-row>
            <b-col lg="6"></b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable1"
                  :data="data"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                >
                  <el-table-column
                    v-for="title in titles"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    sortable="custom"
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  ></el-table-column>
                </data-tables>
              </div>
            </b-col>
          </b-row>

          <div slot="footer">
            <div class="form-actions">
              <el-row>
                <el-col>
                  <b-button variant="primary" @click="buscar">
                    <i class="fa fa-refresh"></i> Refrescar
                  </b-button>
                  <b-button variant="primary" @click="importarExcel">
                    <i class="fa fa-file-excel-o"></i> Importar
                  </b-button>
                  <b-button variant="primary" @click="descargarExcel">
                    <i class="fa fa-file-excel-o"></i> Exportar
                  </b-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      v-model="showModalCargar"
      size="l"
      @close="showModalCargar = false"
      @ok="submitUpload"
      ok-title="Importar"
      cancel-title="Cancelar"
    >
      <div slot="modal-header">
        <strong>Importar Excel</strong>
      </div>
      <b-row>
        <b-col>
          <b-form id="frmFile">
            <input type="file" @change="onFileChange" />
          </b-form>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      size="xl"
      v-model="showModalErrores"
      @ok="showModalErrores = false"
      ok-title="Cerrar"
      ok-only
      hide-header
    >
      <div>
        <strong>Errores en la Importación</strong>
        <b-alert
          v-model="showModalErrores"
          variant="danger"
        >La información no fue importada dado que existen los siguientes errores en el archivo Excel seleccionado:</b-alert>
      </div>
      <b-row>
        <b-col>
          <div ref="refTable">
            <data-tables
              ref="refTable1"
              :data="dataErrores"
              name="table"
              class="table-responsive"
              :current-page.sync="pagina"
              :table-props="tableProps2"
              :filters="filtersErrores"
              :page-size="10"
              :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
              layout="table"
            >
              <el-table-column
                v-for="title in titlesErrores"
                :min-width="title.minwidth"
                :prop="title.prop"
                :label="title.label"
                :key="title.label"
                :align="title.align"
                sortable="custom"
                :formatter="formatter"
                name="table"
                class="table-responsive"
              ></el-table-column>
            </data-tables>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiRubros from "@/components/services/apiRubros";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import download from "downloadjs";

import XLSX from "xlsx";

var state = {
  tickets: [{ name: "test" }],
  headers: ["Test header"]
};

export default {
  name: "Rubros",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch,
    Datepicker
  },
  data: function() {
    return {
      archivo: state,
      porinsertar: 0,
      cargafinalizada: true,
      errores: "",
      showModalErrores: false,
      showDismissibleAlert: false,
      exportar: false,
      tieneAcceso: true,
      showModalCargar: false,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },

      data: [],
      dataErrores: [],
      nombreexcel: "Rubros",
      titles: [
        {
          prop: "srbpoliza",
          label: "Póliza",
          align: "left",
          minwidth: "100"
        },
        {
          prop: "srbramo",
          label: "Ramo",
          align: "left",
          minwidth: "70"
        },
        {
          prop: "srbasegurado",
          label: "Código",
          align: "left",
          minwidth: "100"
        },
        {
          prop: "srbnombreaseg",
          label: "Asegurado",
          align: "left",
          minwidth: "300"
        },
        {
          prop: "srbrubro",
          label: "Rubro",
          align: "left",
          minwidth: "300"
        },
        {
          prop: "srbgrupo",
          label: "Grupo",
          align: "left",
          minwidth: "100"
        },
        {
          prop: "srbnombrecorr",
          label: "Corredor",
          align: "left",
          minwidth: "200"
        },
        {
          prop: "srbusumodif",
          label: "Modificación",
          align: "left",
          minwidth: "150"
        },
        {
          prop: "srbfmodif",
          label: "Fecha",
          align: "left",
          minwidth: "150"
        }
      ],
      filters: [
        {
          prop: [
            "srbpoliza",
            "srbramo",
            "srbasegurado",
            "srbnombreaseg",
            "srbrubro",
            "srbgrupo",
            "srbnombrecorr",
            "srbusumodif",
            "srbfmodif"
          ],
          value: ""
        }
      ],

      titlesErrores: [
        {
          prop: "srbpoliza",
          label: "Póliza",
          align: "left",
          minwidth: "100"
        },
        {
          prop: "srbramo",
          label: "Ramo",
          align: "left",
          minwidth: "70"
        },
        {
          prop: "srbasegurado",
          label: "Código",
          align: "left",
          minwidth: "100"
        },
        {
          prop: "srbnombreaseg",
          label: "Asegurado",
          align: "left",
          minwidth: "300"
        },
        {
          prop: "srbrubro",
          label: "Rubro",
          align: "left",
          minwidth: "300"
        },
        {
          prop: "srbgrupo",
          label: "Grupo",
          align: "left",
          minwidth: "100"
        },
        {
          prop: "srbnombrecorr",
          label: "Corredor",
          align: "left",
          minwidth: "200"
        },
        {
          prop: "srberror",
          label: "Errores",
          align: "left",
          minwidth: "200"
        }
      ],
      filtersErrores: [
        {
          prop: [
            "srbpoliza",
            "srbramo",
            "srbasegurado",
            "srbnombreaseg",
            "srbrubro",
            "srbgrupo",
            "srbnombrecorr",
            "srberror"
          ],
          value: ""
        }
      ],

      mostrarFechas: true,
      datosFormulario: {},
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},

      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 300
      }
    };
  },
  methods: {
    formatNumber(n) {
      console.log(n);
      n = String(n).replace(/\D/g, "");
      return n === "" ? n : Number(n).toLocaleString();
    },

    totales(param) {
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }

        const values = data.map(item => Number(item[column.property]));

        if (!values.every(value => isNaN(value))) {
          sums[index] = this.$numeral(
            values.reduce((prev, curr) => {
              const value = Number(curr);

              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          ).format();
          /*
             sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0);
              */
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },

    exportarExcel() {
      this.$nextTick(function() {
        var tabla = document.getElementById("tableExcel");
        var data = XLSX.utils.table_to_sheet(tabla);
        const workbook = XLSX.utils.book_new();
        const filename = "Export";
        XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}.xlsx`);
      });
    },

    buscar() {
      this.errores = "";
      this.showDismissibleAlert = false;
      this.$Progress.start();

      return apiRubros
        .recuperar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          "REC"
        )
        .then(response => {
          response.data = this.keysMinuscula(response.data);
          this.data = response.data.res;
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();

          if (this.data != null) {
            this.exportar = true;
          } else {
            this.exportar = false;
          }
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    formatter(row, column) {
      if (column.property == "srbfmodif" && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      } else {
        return row[column.property];
      }
    },

    descargarExcel: function() {
      var cuerpo = "";
      var columnas = this.titles;

      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo +=
        "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo +=
        "<td colspan=" +
        columnas.length +
        " class=xl689618 width=698 style='width:526pt;" +
        xl689618 +
        "'>Registro de Rubros</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      for (var i = 0; i < columnas.length; i++) {
        cuerpo +=
          "<td class=xl679618 style='border-left:none;" +
          xl679618 +
          "'>" +
          columnas[i].label +
          "</td>\n";
      }
      cuerpo += "</tr>\n";

      //Data bloque 1
      for (var key in this.data) {
        if (this.data[key]["srbpoliza"] == undefined) {
          this.data[key]["srbpoliza"] = "";
        }
        if (this.data[key]["srbramo"] == undefined) {
          this.data[key]["srbramo"] = "";
        }
        if (this.data[key]["srbasegurado"] == undefined) {
          this.data[key]["srbasegurado"] = "";
        }
        if (this.data[key]["srbnombreaseg"] == undefined) {
          this.data[key]["srbnombreaseg"] = "";
        }
        if (this.data[key]["srbrubro"] == undefined) {
          this.data[key]["srbrubro"] = "";
        }
        if (this.data[key]["srbgrupo"] == undefined) {
          this.data[key]["srbgrupo"] = "";
        }
        if (this.data[key]["srbnombrecorr"] == undefined) {
          this.data[key]["srbnombrecorr"] = "";
        }

        cuerpo +=
          "<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo +=
          "<td class=xl649618 style='border-top:none;border-left:none;" +
          xl649618 +
          "'>" +
          this.data[key]["srbpoliza"] +
          "</td>\n";
        cuerpo +=
          "<td class=xl649618 style='border-top:none;border-left:none;" +
          xl649618 +
          "'>" +
          this.data[key]["srbramo"] +
          "</td>\n";
        cuerpo +=
          "<td class=xl649618 style='border-top:none;border-left:none;" +
          xl649618 +
          "'>" +
          this.data[key]["srbasegurado"] +
          "</td>\n";
        cuerpo +=
          "<td class=xl649618 style='border-top:none;border-left:none;" +
          xl649618 +
          "'>" +
          this.data[key]["srbnombreaseg"] +
          "</td>\n";
        cuerpo +=
          "<td class=xl649618 style='border-top:none;border-left:none;" +
          xl649618 +
          "'>" +
          this.data[key]["srbrubro"] +
          "</td>\n";
        cuerpo +=
          "<td class=xl649618 style='border-top:none;border-left:none;" +
          xl649618 +
          "'>" +
          this.data[key]["srbgrupo"] +
          "</td>\n";
        cuerpo +=
          "<td class=xl649618 style='border-top:none;border-left:none;" +
          xl649618 +
          "'>" +
          this.data[key]["srbnombrecorr"] +
          "</td>\n";
        cuerpo += "</tr>\n";
      }
      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    importarExcel: function() {
      this.showModalCargar = true;
    },

    submitUpload: function() {
      this.$Progress.start();
      var excel = [];
      excel = this.archivo.tickets;
      this.cargafinalizada = false;

      apiRubros
        .eliminar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )
        .then(response => {
          var insert = "";
          var cont = 0;
          this.porinsertar =
            excel.length / 30 == Math.trunc(excel.length / 30)
              ? excel.length / 30
              : Math.trunc(excel.length / 30) + 1;

          for (var i = 0; i < excel.length; i++) {
            insert += excel[i][0] + ":";
            insert += excel[i][1] + ":";
            insert += excel[i][2] + ":";
            insert += excel[i][3] + ":";
            insert += excel[i][4] + ":";
            insert += excel[i][5] + ":";
            insert += excel[i][6] + ";";

            cont += 1;

            if (cont == 30 || i == excel.length - 1) {
              cont = 0;

              apiRubros
                .leer_archivo(
                  this.$session.get("mail"),
                  this.$session.get("usuarioInterno"),
                  insert
                )
                .then(response => {
                  this.porinsertar -= 1;
                })
                .catch(error => {
                  this.$Progress.finish();
                  this.crearNotificacion("Error de sistema", error, "error");
                  return;
                });

              insert = "";
            }
          }
        })
        .catch(error => {
          this.$Progress.finish();
          this.crearNotificacion("Error de sistema", error, "error");
          return;
        });
    },

    onFileChange: function onFileChange(e) {
      let _this = this;

      var files = e.target.files || e.dataTransfer.files;

      var i = 0;
      var f = "";

      for (i = 0, f = files[i]; i != files.length; ++i) {
        var reader = new FileReader(),
          name = f.name;

        reader.onload = function(e) {
          data = e.target.result;

          var o = "";
          var l = 0;
          var w = 10240;

          for (; l < data.byteLength / w; ++l)
            o += String.fromCharCode.apply(
              null,
              new Uint8Array(data.slice(l * w, l * w + w))
            );
          o += String.fromCharCode.apply(
            null,
            new Uint8Array(data.slice(l * w))
          );

          var results;
          var data = e.target.result;
          var fixedData = o; //fixdata(data),

          try {
            var workbook = XLSX.read(btoa(fixedData), { type: "base64" });
          } catch (error) {
            if (_this.mensajeValidacionCampo.cargar == undefined)
              _this.$set(
                _this.mensajeValidacionCampo,
                "cargar",
                "Excel con formato errado"
              );
            else
              _this.mensajeValidacionCampo.cargar = "Excel con formato errado";
          }

          var firstSheetName = workbook.SheetNames[0];
          var worksheet = workbook.Sheets[firstSheetName];

          var headers = [],
            range = XLSX.utils.decode_range(worksheet["!ref"]);
          var C,
            R = range.s.r; /* start in the first row */
          for (C = range.s.c; C <= range.e.c; ++C) {
            /* walk every column in the range */
            var cell =
              worksheet[
                XLSX.utils.encode_cell({ c: C, r: R })
              ]; /* find the cell in the first row */
            var hdr = "UNKNOWN " + C; // <-- replace with your desired default
            if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
            headers.push(hdr);
          }

          state.headers = headers;

          results = XLSX.utils.sheet_to_json(worksheet);

          var cols = state.headers;

          var list = new Array();

          for (var i = 0; i < results.length; i++) {
            var a = [];

            for (var j = 0; j < cols.length; j++) {
              a[j] = results[i][cols[j]];
            }

            list.push(a);
          }

          //state.tickets=results;
          state.tickets = list;
          this.archivo = state;
        };

        reader.readAsArrayBuffer(f);
      }
    },

    export: async function(data, filename) {
      if (typeof this.beforeFinish === "function") await this.beforeFinish();
      download(data, filename, "application/vnd.ms-excel");
    },

    convierteFecha(fechaEntrada) {
      if (fechaEntrada != undefined && fechaEntrada.length != 0) {
        var fecha = new Date(fechaEntrada);

        var dia = ("0" + fecha.getUTCDate()).slice(-2);
        var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2);
        var año = fecha.getUTCFullYear();

        fecha = dia + "-" + mes + "-" + año;

        return fecha;
      } else {
        return fechaEntrada;
      }
    },

    buscarErrores() {
      this.errores = "";
      this.$Progress.start();

      return apiRubros
        .recuperar_errores(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          "REC"
        )
        .then(response => {
          response.data = this.keysMinuscula(response.data);
          this.dataErrores = response.data.res;
          this.$Progress.finish();

          if (this.dataErrores.length > 0) {
            //mostrar errores
            this.showModalErrores = true;
          } else {
            //finalizada importación
            this.crearNotificacion(
              "Importar Excel",
              "Importado con éxito.",
              "success"
            );
            this.buscar();
          }
        })
        .catch(error => {
          this.$Progress.finish();
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.buscar();
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    },

    cargafinalizada: function(newCargafinalizada, oldCargafinalizada) {
      if (newCargafinalizada) {
        this.cargafinalizada = true;
        this.$Progress.finish();
        this.showDismissibleAlert = true;
      }
    },

    porinsertar: {
      handler(value, oldValue) {
        if (value == 0) {
          this.$Progress.finish();
          this.buscarErrores();
        }
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.modal-xl {
  max-width: 90% !important;
}
</style>